import { create } from 'zustand';
import { AnalysisTableData } from '~apis/analysis';
import { LabeledBankAccountTransaction } from '~apis/cash-flow-overview/transactions/getTransactions';

export type TempLabelData = Partial<LabeledBankAccountTransaction>;

interface Store {
  analysisData:
    | (AnalysisTableData & {
        edited?: boolean;
      })
    | null;
  setAnalysisData: (
    data: Partial<AnalysisTableData> & {
      edited?: boolean;
    },
  ) => void;
}

const initialState: Omit<Store, 'setAnalysisData'> = {
  analysisData: null,
};

const useAnalysisTableStore = create<Store>((set, get) => ({
  ...initialState,
  setAnalysisData: (data) => {
    set({
      // @ts-ignore
      analysisData: {
        ...get().analysisData,
        ...data,
        edited: data.edited ?? true,
      },
    });
  },
}));

export default useAnalysisTableStore;
